import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageProvider";
import { Check } from "lucide-react";
import { IMAGES } from "@/lib/brand";

export const WhyChooseUs = () => {
  const { t } = useLang();
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative scroll-mt-24 overflow-hidden bg-white py-24 dark:bg-[#020617] md:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <div className="inline-flex items-center gap-2 rounded-full border border-[#1E3A8A]/15 bg-[#1E3A8A]/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#1E3A8A] dark:border-white/10 dark:bg-white/5 dark:text-[#A5B4FC]">
              {t.why.eyebrow}
            </div>
            <h2 className="mt-5 font-display text-[clamp(2rem,4.2vw,3.25rem)] font-bold leading-tight tracking-tight text-[#0F172A] dark:text-white">
              {t.why.title}
            </h2>

            <ul className="mt-10 grid gap-3 sm:grid-cols-2">
              {t.why.reasons.map((r, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.05 }}
                  data-testid="why-reason"
                  className="group flex items-start gap-3 rounded-2xl border border-slate-200/70 bg-white p-4 transition-all hover:border-[#7C3AED]/40 hover:shadow-elevated dark:border-white/5 dark:bg-[#0F172A]"
                >
                  <div className="mt-0.5 flex h-7 w-7 flex-none items-center justify-center rounded-full bg-gradient-to-br from-[#2563EB] to-[#7C3AED] text-white shadow-glow-blue">
                    <Check className="h-4 w-4" strokeWidth={3} />
                  </div>
                  <span className="text-sm font-medium leading-relaxed text-slate-800 dark:text-slate-100">
                    {r}
                  </span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-3xl shadow-elevated ring-1 ring-black/5">
              <img src={IMAGES.warehouse} alt="" className="h-[560px] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-[#1E3A8A]/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-7 text-white">
                <div className="font-display text-3xl font-bold tracking-tight">
                  18 Jahre
                </div>
                <div className="mt-1 text-sm text-slate-200">
                  vertrauensvolle Personaldienstleistung in Deutschland.
                </div>
              </div>
            </div>
            <div className="absolute -bottom-8 -left-8 h-40 w-40 -z-10 rounded-3xl bg-gradient-to-br from-[#2563EB] to-[#7C3AED] opacity-30 blur-2xl" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
